import { Component, Input, OnInit } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { Course } from "src/app/models/course";
import { Lesson } from "src/app/models/lesson";
import { Resources } from "src/app/models/resources";
import { Teacher } from "src/app/models/teacher";
import { TeacherProvider } from "src/app/providers/teacher/teacher.provider";
import { MessagePopoverButton, MessagePopoverComponent } from "../message-popover/message-popover.component";

@Component({
  selector: "app-move-copy-lesson",
  templateUrl: "./move-copy-lesson.component.html",
  styleUrls: ["./move-copy-lesson.component.scss"],
})
export class MoveCopyLessonComponent implements OnInit {
  selectedCourse: Course;
  actionTypeRadio: string = "move";
  @Input() teacher: Teacher = Teacher.defaults();
  @Input() lesson: Lesson;
  @Input() course: Course;
  _resources: Resources = Resources.defaults();
  get resources(): Resources {
    return this._resources;
  }

  @Input() set resources(resources: Resources) {
    this._resources = resources || Resources.defaults();
  }

  constructor(
    private popoverCtrl: PopoverController,
    private teacherProvider: TeacherProvider
  ) {}

  ngOnInit() {}

  isLoading: boolean = false;

  get courses(): Course[] {
    /* 
      filter course based on 
      1. If course class type is the same
      2. Remove course from list that we selected from lesson tile.
    */
      if(!this.teacher?.activeCourses) return;
      let courses = this.teacher?.activeCourses.filter(
        (e) => 
        e.classType === this.course.classType && 
        e.uuid != this.course.uuid
      );
    return courses;
  }

  onCancel() {
    this.popoverCtrl.dismiss(null);
  }

  onSubmit() {
    this.isLoading = true;
    if (this.actionTypeRadio == "copy") {
      this.onCopyCourse();
    } else {
      this.onMoveCourse();
    }
  }

  onCopyCourse() {
    const lesson = this.lesson.unsavedCopy();
    this.teacherProvider.addLesson(this.selectedCourse, lesson);
    this.isLoading = false;
    this.onCancel();
  }

  onMoveCourse() {
    // Move lesson to selected course
    const selectedLesson = this.lesson.unsavedCopy();
    const selectedCourse = this.teacher.findCourse(this.selectedCourse.uuid);
    this.teacherProvider.addLesson(selectedCourse, selectedLesson);

    //  delete lesson from selected course
    this.teacherProvider.updateCourse(this.selectedCourse);
    this.teacherProvider.deleteLesson(this.selectedCourse, this.lesson);

    this.teacherProvider.saveTeacher();
    this.isLoading = false;
    this.onCancel();
  }

  getCourseTitle(course: Course): string {
    const name: string = this.resources.findCollection(course.collectionUuid)
      .name
      ? this.resources.findCollection(course.collectionUuid).name
      : "";
    return `${name}`;
  }

  getCourseSubDetails(course: Course): string {
    const date: string = `${course.startDate.month} ${course.startDate.day}`;
    return ` - ${course.classType} - ${date}`;
  }

  get isCourse(): boolean{
    if(this.courses && this.courses.length != 0 ) return true;
    return false;
  }

  onMoveCopyConfirmationPopupModal(){
    MessagePopoverComponent.present(this.popoverCtrl, 
      `${this.capitalizeFirstLetter(this.actionTypeRadio)} lesson plan` ,
      `Are you sure you want to ${this.actionTypeRadio} lesson plan to another semester?`, false, false, [
      { name: 'Cancel', type: MessagePopoverButton.Type.Cancel },
      { name: `${this.capitalizeFirstLetter(this.actionTypeRadio)}`, type: MessagePopoverButton.Type.Submit, action: () => {
        this.onSubmit()
      }}
    ])
  }

  capitalizeFirstLetter(str) {
    return str[0].toUpperCase() + str.slice(1);
  }
}
